import { useState } from 'react';
import groupBy from 'lodash/groupBy';

import useStore from './useStore';

const defaultFilters = {
  sortBy: 'name',
  orderBy: 'ascending',
  userStatuses: ['active', 'pending'],
  userRoles: null,
};

const useLocalUserFilters = () => {
  const { usersStore } = useStore();
  const [search, setSearch] = useState('');
  const [open, setOpen] = useState(false);
  const [filters, setFilters] = useState(defaultFilters);

  const selectedRoleIds = filters.userRoles || usersStore.defaultRoleIds;
  const areFiltersApplied =
    filters.userStatuses.length !== defaultFilters.userStatuses.length ||
    selectedRoleIds.length !== usersStore.defaultRoleIds.length ||
    selectedRoleIds.some(id => !usersStore.defaultRoleIds.includes(id)) ||
    filters.orderBy !== defaultFilters.orderBy ||
    filters.sortBy !== defaultFilters.sortBy;

  const resetFilters = () => setFilters(defaultFilters);
  const users = usersStore.filteredAvailableUsers(filters, search);

  const groupedUsers = groupBy(
    users.filter(user => !!user.currentEstablishmentRole._roleuser_locked === false),
    ({ last_name }) => last_name?.charAt(0).toUpperCase() || '#',
  );

  return {
    search,
    setSearch,
    areFiltersApplied,
    openFilters: () => setOpen(true),
    resetFilters,
    users,
    groupedUsers,
    sortedGroupKeys: Object.keys(groupedUsers).sort((a, b) => a.localeCompare(b)),
    filterProps: {
      open,
      onDismiss: () => setOpen(false),
      filters,
      defaultFilters,
      onApply: setFilters,
      onReset: resetFilters,
    },
  };
};

export default useLocalUserFilters;
